module.exports = __webpack_public_path__ + "media/state-press-3_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-3_1600.jpg
// module id = 44
// module chunks = 0